import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PwaService } from '@core/services/pwa.service';

@Component({
  selector: 'app-pwa-confirm',
  templateUrl: './pwa-confirm.component.html',
  styleUrls: ['./pwa-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaConfirmComponent {

  constructor(public pwaService: PwaService) { }
}
